export default __webpack_public_path__ + "static/media/ELIMINA_ICONA.7ce52cfe.svg";